var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.computedColor}},'v-icon',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.value ? _vm.computedIconOn : _vm.computedIconOff))])
}
var staticRenderFns = []

export { render, staticRenderFns }